/**
 * Formats a US phone number.
 *
 * Supported formats:
 *  - 1 (800) 777-7777
 *  - (777) 777-7777
 *
 * Enforces max length:
 *  - 11 digits if starting with 1
 *  - 10 digits otherwise
 */
export const formatPhone = (value = "") => {
  if (!value) return "";

  // Strip non-digits
  let digits = value.replace(/\D/g, "");

  // 🇺🇸 Handle country code 1
  const hasCountryCode = digits.startsWith("1");

  // Enforce max length
  digits = hasCountryCode
    ? digits.substring(0, 11)
    : digits.substring(0, 10);

  // Country code case: 1XXXXXXXXXX
  if (hasCountryCode) {
    const country = "1";
    const rest = digits.substring(1);

    const part1 = rest.substring(0, 3);
    const part2 = rest.substring(3, 6);
    const part3 = rest.substring(6, 10);

    if (rest.length > 6) return `${country} (${part1}) ${part2}-${part3}`;
    if (rest.length > 3) return `${country} (${part1}) ${part2}`;
    if (rest.length > 0) return `${country} (${part1}`;
    return country;
  }

  // Standard US number: XXXXXXXXXX
  const part1 = digits.substring(0, 3);
  const part2 = digits.substring(3, 6);
  const part3 = digits.substring(6, 10);

  if (digits.length > 6) return `(${part1}) ${part2}-${part3}`;
  if (digits.length > 3) return `(${part1}) ${part2}`;
  if (digits.length > 0) return `(${part1}`;
  return "";
};
